import {
    FILE_INPUT_ACTION, IMG_ACTION,
    NONE_FILE_DATA_ACTION,
    UPLOAD_ACTION,
    UPLOAD_BUTTON_ACTION,
    UPLOAD_BUTTON_VALIDATION_ACTION
} from './type'

export function fileInputAction (state, fileData) {
    return {
        type: FILE_INPUT_ACTION,
        fileData,
        fileValid: !state.fileValid
    }
}

export function uploadAction (state) {
    return {
        type: UPLOAD_ACTION,
        upload: !state.upload
    }
}

export function uploadButtonValidationAction (state) {
    return {
        type: UPLOAD_BUTTON_VALIDATION_ACTION,
        fileValid: !state.fileValid
    }
}

export function uploadButtonAction (state, response) {
    return {
        type: UPLOAD_BUTTON_ACTION,
        upload: true,
        verificationStatus: response
    }
}

export function noneFileDataAction (state) {
    return {
        type: NONE_FILE_DATA_ACTION,
    }
}

export function imgAction (state, showModal, src, alt) {
    return {
        type: IMG_ACTION,
        showModal,
        src,
        alt
    }
}